import {
	CreateAccountResponse,
	CreateAccountSubmission, ExpireCurrentTokenResponse,
	UpdateAccountSubmission, CommandData, CommandReponse,
	ChangeSchemaSubmission,
	ExpireCurrentTokenSubmission,
	BanTokenSubmission,
	UpdateAccountRemarkSubmission,
	AccountMinimumData,
	ChangeProgramSubmission,
	TypicalResponse,
	UpdateAccountExprirySubmission,
} from './models.def';
import mwx from '@/store/modules/mediumwarex';
import fb from './gobi-mw-firestore';
import store from '@/store';
import userx from './modules/userx';
import firebase from 'firebase';

const db: firebase.firestore.Firestore = fb.db;
const functions: firebase.functions.Functions = fb.functions;

export class Mediumwares {


	public currentAccountId: string | null = null;

	private _unsubscribeListenToAllAccounts: (() => void) | null = null;
	private _unsubscribeListenToInstallers: (() => void) | null = null;

	constructor() {

		// auto init when user.supportLvl >= 1
		if (userx.supportLvl && userx.supportLvl >= 1) {
			this.init();
		}
		store.watch(
			(states, getters) => getters['userx/supportLvl'],
			(newValue, oldValue) => {
				if (!newValue) {
					if (this._unsubscribeListenToAllAccounts) {
						this._unsubscribeListenToAllAccounts();
						this._unsubscribeListenToAllAccounts = null;
					}
					if (this._unsubscribeListenToInstallers) {
						this._unsubscribeListenToInstallers();
						this._unsubscribeListenToInstallers = null;
					}
					mwx.updateAllAccounts([]);
					mwx.updateInstallers({ x86: null, x64: null, version: null });
				} else if (newValue >= 1) {
					this.init();
				}
			});
	}


	public async init() {
		if (!this._unsubscribeListenToAllAccounts) {
			this.listenToAllAccountsSnapshop();
		}
		if (!this._unsubscribeListenToInstallers) {
			this._unsubscribeListenToInstallers = db.doc('mediumware/version')
				.onSnapshot((doc) => {
					if (!doc.exists) {
						mwx.updateInstallers({ x86: null, x64: null, version: null });
						return;
					}
					const data = doc.data()!;

					const x86 = data['32bit'];
					const x64 = data['64bit'];
					const version = data.version;

					mwx.updateInstallers({ x86, x64, version });
				});
		}
	}

	public listenToAllAccountsSnapshop() {
		this._unsubscribeListenToAllAccounts = db.collection('system/allAccounts/batches')
			.onSnapshot((docs) => {
				if (docs.empty) {
					mwx.updateAllAccounts([]);
					return;
				}

				const allAccounts: AccountMinimumData[] = [];
				docs.forEach((doc) => {
					const batchData = doc.data();
					const accounts = batchData.accounts;
					if (accounts) {
						allAccounts.push(...Object.values(accounts)
							.filter((account) => account !== null) as AccountMinimumData[]);
					}
				});

				mwx.updateAllAccounts(allAccounts);
			});
	}

	public async createAccount(submission: CreateAccountSubmission): Promise<CreateAccountResponse> {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		if (!submission.companyName || submission.companyName === ''
			|| !submission.path || submission.path === '') {
			return { success: false, errorMessage: 'Invalid Parameter' };
		}
		submission.interval = submission.interval || 300;
		submission.softwareType = submission.softwareType || 'sql';
		submission.programId = submission.programId || `${submission.softwareType}-default`;
		try {
			const result = await functions.httpsCallable('createAccount')(submission);
			return { success: true, ...result.data } as CreateAccountResponse;
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.detail || error.code, errorMessage: error.message };
		}
	}
	public async expireCurrentToken(submission: ExpireCurrentTokenSubmission): Promise<ExpireCurrentTokenResponse> {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		const { accountId, doNotMakeNew } = submission;
		try {
			const result = await functions.httpsCallable('expireCurrentToken')({ accountId, doNotMakeNew });
			return { success: true, ...result.data } as ExpireCurrentTokenResponse;
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.detail || error.code, errorMessage: error.message };
		}
	}
	public async updateAccountRemark(submission: UpdateAccountRemarkSubmission) {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		if (!submission.companyRemark) {
			return { success: false, errorCode: 'invalid-argument', errorMessage: 'companyRemark is missing' };
		}
		try {
			const response: any = { success: true };

			const result = await functions
				.httpsCallable('updateCompanyRemark')(submission);

			const command = result.data as CommandData;
			response.command = command;

			return response;
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}

	}
	public async updateAccountExpiry(submission: UpdateAccountExprirySubmission) {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		if (!submission.expiryTime) {
			return { success: false, errorCode: 'invalid-argument', errorMessage: 'expiryTime is missing' };
		}
		try {
			const response: any = { success: true };

			const result = await functions
				.httpsCallable('updateCompanyExpiryTime')(submission);

			const command = result.data as CommandData;
			response.command = command;

			return response;
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}

	}
	public async updateAccount(submission: UpdateAccountSubmission): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		// if (submission.path && submission.path.substr(-4).toLocaleLowerCase() !== '.fdb') {
		// 	return { success: false, errorCode: 'invalid-argument', errorMessage: 'Path name must end with .FDB' };
		// }
		if (submission.payroll && submission.payroll.substr(-4).toLocaleLowerCase() !== '.fdb') {
			return { success: false, errorCode: 'invalid-argument', errorMessage: 'Path name must end with .FDB' };
		}

		try {
			const response: any = { success: true };
			if (submission.path || submission.payroll !== undefined
				|| submission.interval !== undefined || submission.backendUrl !== undefined) {

				const result = await functions
					.httpsCallable('postCommand')({
						accountId: submission.accountId,
						type: 'changeSettings',
						payload: submission,
					});

				const command = result.data as CommandData;
				response.command = command;
			}
			return response;
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
	public async banOrUnbanToken(submission: BanTokenSubmission) {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		const { accountId, tokenPath, value } = submission;
		const data: any = {};
		data[tokenPath] = value;
		try {
			await db.doc(`accounts/${accountId}`).update(data);
			return { success: true };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
	public async changeSchemaId(submission: ChangeSchemaSubmission): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		if (!submission.schemaId) {
			return { success: false, errorCode: 'invalid-argument', errorMessage: 'Must provide schemaId' };
		}
		try {
			const result = await functions
				.httpsCallable('postCommand')({
					accountId: submission.accountId,
					type: 'changeSchema',
					payload: submission,
				});

			const command = result.data as CommandData;
			return { success: true, command };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
	public async changeProgramId(submission: ChangeProgramSubmission): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		if (!submission.programId) {
			return { success: false, errorCode: 'invalid-argument', errorMessage: 'Must provide schemaId' };
		}
		try {
			const result = await functions
				.httpsCallable('postCommand')({
					accountId: submission.accountId,
					type: 'changeProgram',
					payload: submission,
				});

			const command = result.data as CommandData;
			return { success: true, command };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
	public async syncNow(accountId: string): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(1);
		if (!assert.success) { return assert; }
		try {
			const result = await functions
				.httpsCallable('postCommand')({
					accountId,
					type: 'syncNow',
				});

			const command = result.data as CommandData;
			return { success: true, command };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
	public async purgeSync(accountId: string): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(2);
		if (!assert.success) { return assert; }
		const accountData = mwx.allAccounts.find((acc) => acc.accountId === accountId);
		try {
			const result = await functions
				.httpsCallable('postCommand')({
					accountId,
					type: 'purgeSync',
				});

			const command = result.data as CommandData;
			return { success: true, command };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}

	public async sendLogs(accountId: string, payload?: any): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(1);
		if (!assert.success) { return assert; }
		try {
			const request: any = { accountId, type: 'sendLogs' };
			if (payload && Object.keys(payload).length > 0) {
				request.payload = payload;
			}
			const result = await functions
				.httpsCallable('postCommand')(request);

			const command = result.data as CommandData;
			return { success: true, command };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
	public async sendSettings(accountId: string): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(1);
		if (!assert.success) { return assert; }
		try {
			const result = await functions
				.httpsCallable('postCommand')({
					accountId,
					type: 'sendSettings',
				});

			const command = result.data as CommandData;
			return { success: true, command };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
	public async sendAccounts(accountId: string): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(10);
		if (!assert.success) { return assert; }
		try {
			const result = await functions
				.httpsCallable('postCommand')({
					accountId,
					type: 'sendAccounts',
				});

			const command = result.data as CommandData;
			return { success: true, command };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
	public async restart(accountId: string): Promise<CommandReponse> {
		const assert = fb.assertSupportLvl(3);
		if (!assert.success) { return assert; }
		try {
			const result = await functions
				.httpsCallable('postCommand')({
					accountId,
					type: 'restart',
				});

			const command = result.data as CommandData;
			return { success: true, command };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}

	public async removeAccount(accountId: string): Promise<TypicalResponse> {
		const assert = fb.assertSupportLvl(10);
		if (!assert.success) { return assert; }
		try {
			const result = await functions.httpsCallable('removeAccount')({ accountId });
			return { success: true };
		} catch (error: any) {
			console.error(error);
			return { success: false, error, errorCode: error.code, errorMessage: error.message };
		}
	}
}
const mwz = new Mediumwares();
export default mwz;
